import React from 'react';
import { X, Gift } from 'lucide-react';
import './CyberForestHuntBanner.css';

const CyberForestHuntBanner = ({ onPlay, onClose }) => {
  return (
    <div className="cfh-banner" role="complementary" aria-label="Discount opportunity">
      <div className="cfh-banner-content">
        <Gift size={18} className="cfh-banner-icon" />
        <span className="cfh-banner-text">
          Play the <strong>Cyber Forest Hunt</strong> to unlock 8% off
        </span>
        <button 
          className="cfh-banner-play-btn"
          onClick={onPlay}
          aria-label="Play Cyber Forest Hunt game"
        >
          Play now
        </button>
      </div>
      <button 
        className="cfh-banner-close"
        onClick={onClose}
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default CyberForestHuntBanner;
